// Full-document render of the Oscar account order-history list: PageSkeleton
// wrapping the legacy sealy orders page body.
import React from "react";

import { templates } from "@reactivated";

import { OrderHistoryPageBody } from "../components/OrderHistoryPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderHistoryDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <OrderHistoryPageBody {...props} />
    </PageSkeleton>
);
